module.exports = __webpack_public_path__ + "img/logo.b48f850a.png";